import { render, staticRenderFns } from "./error-notification.vue?vue&type=template&id=495cc1be&"
import script from "./error-notification.vue?vue&type=script&lang=js&"
export * from "./error-notification.vue?vue&type=script&lang=js&"
import style0 from "./error-notification.vue?vue&type=style&index=0&id=495cc1be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports